
import { NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { tablaMultas } from '../../../../shared/data/tables/tabla-multas';
import { NgbdSortableHeader, SortEvent } from '../../../../shared/directives/NgbdSortableHeader';
import {  BehaviorSubject } from 'rxjs';
import { Component,HostListener,  OnInit, QueryList, ViewChildren, ViewEncapsulation } from '@angular/core';
import { InfraccionService } from '../../../../shared/services/infracciones.service';
import { Router } from '@angular/router';
import jsPDF from 'jspdf';
import { Utils } from '../../../../shared/utils/Utils';
import * as XLSX from 'xlsx';
const Swal = require("sweetalert2");
@Component({
  selector: 'app-multas',
  templateUrl: './multas.component.html',
  styleUrls: ['./multas.component.scss']
})
export class MultasComponent implements OnInit {

  public selected = [];
  public filteredTableItem$: BehaviorSubject<tablaMultas[]> = new BehaviorSubject<tablaMultas[]>([]); // Nuevo BehaviorSubject para filtrar
  public searchText: string = ''; // Texto de búsqueda

  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  infracciones: any;
  isSelected = false;

  disabled = true;
  selectedEstado: any;

  cantidadVencidos = 0;
  cantidadPorVencer = 0;
  cantidaVigente = 0;
  totalMultas = 0;
  onNavChange1(changeEvent: NgbNavChangeEvent) {
    if (changeEvent.nextId === 5) {
      changeEvent.preventDefault();
    }
  }



  public show : boolean = false
  openDropdown: any = null; // Variable para controlar qué menú está abierto
  openDropdown2: any = null; // Variable para controlar qué menú está abierto
  sortColumn: string = '';
  sortDirection: string = 'asc'; // 'asc' o 'desc'
  searchTerm: string = '';
  dropdownStates: boolean[] = [];
  estadisticas: { vigentes: number; porVencer: number; vencidos: number;porcentajeVencidos:number,
    porcentajeVigentes:number,porcentajePorVencer:number } = {
    vigentes: 0,
    porVencer: 0,
    vencidos: 0,
    porcentajeVencidos:0,
    porcentajeVigentes:0,
    porcentajePorVencer:0,
  };
  filteredTableItems: InfraccionService[];
  loading: boolean = false;
  

  constructor(private infraccionesService: InfraccionService,private router: Router ) {}

  ngOnInit() {
    this.selectedEstado="";
    this.listarMultas();
    
  }

  pageSize1: number = 5; 
  page1: number = 1;
  totalItems: number;

  @HostListener('document:click', ['$event'])
  closeDropdown(event: Event) {
    this.openDropdown = null;
    this.openDropdown2 = null;
  }

  stopPropagation(event: Event) {
    event.stopPropagation(); // Evita que el clic dentro del dropdown cierre el menú
  }
  // Función para ordenar las columnas
  onSort({ column, direction }: SortEvent) {
    // Restablecemos la dirección de orden de todas las columnas
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    // Establecemos la columna y dirección de orden
   // this.service.sortColumn = column;
   // this.service.sortDirection = direction;
  }

  sortData(column: string) {
  if (this.sortColumn === column) {
    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
  } else {
    this.sortColumn = column;
    this.sortDirection = 'asc';
  }

  const listToSort = this.filteredTableItems.length ? this.filteredTableItems : this.infracciones;

  listToSort.sort((a, b) => {
    let aVal = this.getNestedValue(a, column);
    let bVal = this.getNestedValue(b, column);

    if (typeof aVal === 'string') aVal = aVal.toLowerCase();
    if (typeof bVal === 'string') bVal = bVal.toLowerCase();

    if (aVal < bVal) return this.sortDirection === 'asc' ? -1 : 1;
    if (aVal > bVal) return this.sortDirection === 'asc' ? 1 : -1;
    return 0;
  });

  this.page1 = 1; // Reiniciar paginación
}

getNestedValue(obj: any, path: string): any {
  return path.split('.').reduce((acc, part) => acc && acc[part], obj) ?? '';
}

  
  get filteredinfracciones() {
    if (!this.searchTerm) {
      return this.infracciones; // Mostrar todos los datos si no hay búsqueda
    }

    const term = this.searchTerm.toLowerCase();
    return this.infracciones.filter(Infraccion => {
      // Ajusta los campos por los que quieres buscar
      return (
        Infraccion.documento.toLowerCase().includes(term) ||
        Infraccion.noombre.toLowerCase().includes(term) ||
        Infraccion.fecha.toLowerCase().includes(term) ||
        Infraccion.tipo.toLowerCase().includes(term) ||
        Infraccion.numero.toLowerCase().includes(term) ||
        Infraccion.codigo.toLowerCase().includes(term) ||
        Infraccion.valortotal.toLowerCase().includes(term) ||
        Infraccion.vrpagado.toLowerCase().includes(term) ||
        Infraccion.vrsaldo.toLowerCase().includes(term) ||
        Infraccion.fechacompromiso.toLowerCase().includes(term) ||
        Infraccion.observaciones.toLowerCase().includes(term) ||
        Infraccion.registro.toLowerCase().includes(term) ||
        Infraccion.estado.toLowerCase().includes(term)
      );
    });
  }

  toggleDropdown(index: number) {
    this.dropdownStates = this.dropdownStates.map((state, i) => (i === index ? !state : false));
  }

  
  listarMultas(): void {
    this.loading = true;
    this.infraccionesService.getInfracciones().subscribe({
      next: (data) => {
        console.log("📋 Datos recibidos:", data);
        this.infracciones = data.infracciones; // Lista de infracciones
        this.filteredTableItems = [...this.infracciones]; // Para mostrar en la tabla
       
       
       this.infraccionesService.actualizarEstadisticas(data.conteoPorEstado);
         this.totalMultas = this.cantidadVencidos+ this.cantidadPorVencer + this.cantidaVigente;
        this.loading = false;
      },
      error: (err) => {
        console.error("❌ Error cargando infracciones:", err);
        this.loading = false;
      },
    });
  }
  

  getDiasRestantes(vencelic: string): number {
    if (!vencelic) return NaN; // Manejar valores nulos o indefinidos
  
    const hoy = new Date();
    const fechaVencimiento = new Date(vencelic);
    const diferenciaDias = Math.ceil((fechaVencimiento.getTime() - hoy.getTime()) / (1000 * 60 * 60 * 24));
  
    return diferenciaDias;
  }
  
  //recibe el id de la tabla vista, nombre con el que descargará el archivo, titulo del documento
 exportToPDF(tableId:string,nameFile:string,titleFile:string) {
  Utils.exportToPDF(tableId, nameFile,titleFile);
  }

exportarExcel(nameFile: string) {
  if (!this.filteredTableItems || this.filteredTableItems.length === 0) {
    Swal.fire({
      icon: 'info',
      title: 'Sin datos',
      text: 'No hay datos filtrados para exportar.',
      confirmButtonText: 'Entendido'
    });
    return;
  }

  // Transformar y excluir campos
  const datosParaExcel = this.filteredTableItems.map(item => ({
    Numero: item.numero,
    Documento: item.documento,
    Nombre: item.propietario 
      ? `${item.propietario.primernombre || ''} ${item.propietario.segundonombre || ''} ${item.propietario.papellidos || ''} ${item.propietario.seapellidos || ''}`.trim()
      : '',
    Fecha: item.fecha,
    Tipo: item.tipo,
    Código: item.codigo,
    Valor_Total: item.valortotal,
    Valor_Pagado: item.vrpagado,
    Saldo: item.vrsaldo,
    Fecha_Compromiso: item.fechacompromiso,
    Estado: item.estado,
    Observaciones: item.observaciones || ''
  }));

  // Crear hoja
  const worksheet = XLSX.utils.json_to_sheet(datosParaExcel);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Datos');

  // Guardar archivo
  XLSX.writeFile(workbook, `${nameFile}.xlsx`);
}

  
  filterData(): void {
    if (!this.infracciones || this.infracciones.length === 0) {
      this.filteredTableItems = [];
      this.totalItems = 0;
      return;
    }

    let filtered = [...this.infracciones];

    if (this.selectedEstado) {
      const estadoNum = Number(this.selectedEstado);
      filtered = filtered.filter(p => p.estado === estadoNum);
    }

    if (this.searchText && this.searchText.trim()) {
      const term = this.searchText.toLowerCase().trim();
      filtered = filtered.filter(p =>
        (p.documento && p.documento.toLowerCase().includes(term)) ||
        (p.noombre && p.noombre.toLowerCase().includes(term))
      );
    }

    this.filteredTableItems = filtered;
    this.totalItems = this.filteredTableItems.length;
    this.page1 = 1;
  }

  filterData1(): void {
    this.filterData();
  }
  
  
  estadoMap: { [key: number]: { label: string; color: string } } = {
    1: { label: 'PAGADO', color: 'badge badge-light-success' },
    2: { label: 'PENDIENTE DE PAGO', color: ' badge badge-light-secondary' },
    3: { label: 'ACUERDO DE PAGO', color: 'badge badge-light-warning' }
  };
  
  
  getEstadoLabel(estado: number): string {
    return this.estadoMap[estado]?.label || 'DESCONOCIDO';
  }
  
  getEstadoColor(estado: number): string {
    return this.estadoMap[estado]?.color || 'gray';
  }
  

  

  
  
  
}

  
